/* Routing */
import { useLocation, Navigate, Outlet } from "react-router-dom";
/* Contexts */
import useAuth from "../../hooks/useAuth";


/** Définition de redirections selon si l'user a le bon token, sinon s'il a
un token mais pas le rôle, sinon pas d'autorisation du tout */
export default function RequireAuth({ allowedRoles }) {
    const { auth } = useAuth();
    const location = useLocation();
    return (
        auth?.roles?.find(role => allowedRoles?.includes(role))
            ? <Outlet/>
            : auth?.username
                ? <Navigate to="/unauthorized" state={{ from: location }} replace />
                : <Navigate to="/pro/login" state={{ from: location }} replace />
    )
}